<template>
  <div>
    <a-upload
    list-type="picture-card"
    :file-list="fileList"
    :customRequest="handleFileUpload"
    :before-upload="beforeFileUpload"
    :disabled="disabled||uploading"
    :remove="handleRemove"
    :accept="accept"
    @preview="preview"
    >
      <a-spin v-if="uploading"/>
      <div v-if="fileList.length < num && !uploading">
        <svg class="icon img-icon" aria-hidden="true">
            <use xlink:href="#gold-icon-shangchuan"></use>
        </svg>
        <div class="ant-upload-text" style="color:#1990FF;">{{text}}</div>
      </div>
    </a-upload>
    <!-- 预览图片 -->
    <imgView ref="imgView" :src.sync="viewSrc"/>
    <!-- <div class="imgUploadView" v-viewer>
      <img v-for="(src,index) in viewImgList" :src="src" :key="index" v-show="false"/>
    </div> -->
  </div>
</template>

<script>
import { fileDeletAPI } from "@/api/file.js";
export default {
  name: "imgUpload",
  props: {
    accept:{
      type: String,
      required: false,
      default: function () {
        return ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG";
      },
    },
    // 文件上传接口的url
    url: {
      type: String,
      required: false,
      default: function () {
        return "/gb-bigtree-file/fileUpload";
      },
    },
    // 上传的文件名称
    name: {
      type: String,
      required: true,
      default: function () {
        return "fileName";
      },
    },
    // 描述文字
    text:{
      type: String,
      required: false,
      default: function () {
        return "上传图片";
      },
    },
    // 上传数量
    num: {
      type: Number,
      required: false,
      default: function () {
        return 1;
      },
    },
    // 可传入接口需要的参数
    paramObj:{
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    file:{
      type: [Object,Array],
      required: false
    },
    disabled:{
      type: [Boolean],
      required: false
    },
    removeaction: {
      //删除时是否删除服务器文件
      type: Boolean,
      required: false,
      default: function() {
        return false;
      }
    },
  },
  data() {
    return {
      fileList: [],
      fileListCur:[],
      uploading: false,
      viewSrc:"",
      viewImgList: [],
      paramObjSelf:this.utils.deepClone(this.paramObj)
    };
  },
  methods: {
    beforeFileUpload(file){
      if(file.name && file.name.indexOf(".") > -1){
        let d_name = file.name.substring(file.name.lastIndexOf('.') + 1);
        if(this.accept.indexOf(d_name) > -1){
          this.fileListCur = [file];
          this.$emit("beforeFileUpload", this.fileList);
        }else{
          this.$message.error("请上传"+this.accept+"格式的文件");
          return false;
        }
      }else{
        this.$message.error("请上传"+this.accept+"格式的文件");
        return false;
      }

    },
    handleFileUpload() {
        const formData = new FormData();
        this.fileListCur.forEach(file => {
          formData.append(this.name, file);
          for(let key in this.paramObjSelf){
            formData.append(key,this.paramObjSelf[key]);
          }
        });
        this.uploading = true;
        this.axios({
            url:this.url,
            data:formData,
            isTransform:false
        }).then((res)=> {

        })
        .catch((data)=> {
            this.uploading = false;
            if(data[0]){
              this.fileList.push({
                name:this.fileListCur[0].name,
                size:this.fileListCur[0].size,
                uid:this.fileListCur[0].uid,
                fileExpdNm:data[0].contentType,
                fileRte:JSON.parse(data[0].savePath).file
              })
              this.$emit("uploadOk",this.fileList,this.paramObjSelf);
            }
        });
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
      if (this.removeaction) {
        const params = {
          fileRte: file.fileRte,
          fileNm: file.name,
          fileExpdNm: file.fileExpdNm,
          fileSize: file.fileSize,
          tblBlId: file.tblBlId,
          fileId: file.fileId||file.uid,
          fileTpCd: file.fileTpCd,
          fileSubTpCd:file.fileSubTpCd,
          id: file.fileId||file.uid,
        };
        fileDeletAPI(params)
          .then(res => {
            this.$emit("remove", file);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$emit("remove", file);
        return true;
      }
    },
    preview(file){
      this.viewSrc = file.url;
      this.$refs.imgView.show();
    }
  },
  watch:{
    paramObj:{
      deep:true,
      immediate:true,
      handler(newVal){
        this.paramObjSelf = this.utils.deepClone(newVal);
      }
    },
    file:{
      immediate:true,
      handler(newVal){
        if(newVal.length > 0 || (newVal && JSON.stringify(newVal) != "{}")){
          this.fileList = [{
            uid: newVal.fileId||newVal.uid,
            name: newVal.fileNm||newVal.name,
            status: 'done',
            url:"/gb-bigtree-file/download/fileDownload/install"+newVal.fileRte+'/'+(newVal.fileNm||newVal.name)
          }]
        }else{
          this.fileList = [];
        }
      }
    }
  }
};
</script>
<style scoped>
.img-icon{
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/img-upload/img-upload.vue